import { queryOptions, skipToken, useQuery } from '@tanstack/react-query'
import type { ProductRecommenderApiGetRecommendationsRequest } from '@itsrever/rever-api'
import { productRecommenderApi } from '@/services/api/productRecommenderApi'

type RecommendationsRequest = Partial<
  ProductRecommenderApiGetRecommendationsRequest['productrecommenderpbGetRecommendationsRequest']
>

export const productRecommendationsQuery = ({
  checkout_id,
  ecommerce_id,
  order_reference,
  channel,
  return_items,
  user_information
}: RecommendationsRequest) =>
  queryOptions({
    queryKey: [
      'product-recommendations',
      channel,
      checkout_id,
      ecommerce_id,
      order_reference,
      return_items,
      user_information
    ] as const,
    queryFn:
      ecommerce_id !== undefined &&
      return_items !== undefined &&
      user_information !== undefined
        ? async () => {
            const { data } = await productRecommenderApi.getRecommendations({
              productrecommenderpbGetRecommendationsRequest: {
                channel,
                checkout_id,
                ecommerce_id: ecommerce_id,
                order_reference,
                return_items,
                user_information
              }
            })

            return data
          }
        : skipToken,
    staleTime: Infinity
  })

export const useProductRecommendations = (request: RecommendationsRequest) =>
  useQuery(productRecommendationsQuery(request))
